module.exports = __webpack_public_path__ + "static/media/main-icon.e261fde8.svg";